function broadcast (componentName, eventName, ...params) {
  this.$children.forEach(child => {
    var childName = child.$options.name

    if (childName === componentName) {
      setTimeout(() => {
        child.$emit(eventName, ...params)
      }, 0)
      // child.$emit.apply(child, [eventName, ...params])
    } else {
      broadcast.apply(child, [componentName, eventName, ...params])
    }
  })
}
export default {
  methods: {
    dispatch (componentName, eventName, ...params) {
      var parent = this.$parent || this.$root
      var parentName = parent.$options.name

      while (parent && (!parentName || parentName !== componentName)) {
        parent = parent.$parent

        if (parent) {
          parentName = parent.$options.name
        }
      }
      if (parent) {
        setTimeout(() => {
          parent.$emit(eventName, ...params)
        }, 0)
        // parent.$emit.apply(parent, [eventName, ...params])
      }
    },
    broadcast (componentName, eventName, ...params) {
      broadcast.call(this, componentName, eventName, ...params)
    }
  }
}
